/* mv6-footer.js — the site-wide footer's behavior (chrome extraction, 14 Aug 2026).
 * One behavior: the menu columns collapse on mobile. Same mechanics as the
 * PDP's content layer had (mv6-content.js keeps its copy ROOT-scoped, so with
 * the footer outside that root this file is the only owner — R-36). */
(function () {
  'use strict';
  var ROOT = document.getElementById('mv6-footer-shell');
  if (!ROOT) return;
  function isMobile() { return window.innerWidth < 900; }

  /* Accessibility (15 Aug 2026). The Sienna widget is loaded by the store's OLD
   * footer section; our chrome extraction suppressed that footer, which took the
   * trigger with it — R-94. This opens the widget's own button, loading Sienna
   * first if nothing else did, and falls back to the statement page if the CDN
   * never answers. Nothing is fetched until the visitor clicks. */
  function openA11y() {
    var b = document.querySelector('.asw-menu-btn');
    if (b) { b.click(); return; }
    if (!window.__mv6Sienna) {
      window.__mv6Sienna = 1;
      var s = document.createElement('script');
      s.src = 'https://website-widgets.pages.dev/dist/sienna.min.js';
      s.defer = true;
      document.head.appendChild(s);
    }
    var tries = 0;
    var t = setInterval(function () {
      var el = document.querySelector('.asw-menu-btn');
      if (el) { clearInterval(t); el.click(); }
      else if (++tries > 40) { clearInterval(t); window.location.href = '/pages/accessibility'; }
    }, 150);
  }

  /* ── R-105 · inline state written at one breakpoint must be cleared at the
   * other. The collapse writes `display:none` straight onto the panel and
   * nothing ever cleared it, so a column a visitor closed on a phone was still
   * missing after a rotate or resize past 900px — where that panel is a static
   * desktop column with no control to reopen it. Found by an outside review,
   * 15 Aug 2026.
   * Restored to `flex`, not to '': the panel's open state IS an inline
   * `display:flex` in mv6-footer.liquid, and clearing the property would drop
   * it to a block and lose the 12px column gap.
   * Desktop→mobile is deliberately NOT reset — whatever the visitor last set
   * on a phone is their state to keep. */
  var wasMobile = isMobile();
  window.addEventListener('resize', function () {
    var m = isMobile();
    if (m === wasMobile) return;
    wasMobile = m;
    if (m) return;
    var panels = ROOT.querySelectorAll('[data-mv6-ft-panel]');
    for (var i = 0; i < panels.length; i++) panels[i].style.display = 'flex';
    var heads = ROOT.querySelectorAll('[data-mv6-ft]');
    for (var j = 0; j < heads.length; j++) {
      heads[j].setAttribute('aria-expanded', 'true');
      var chev = heads[j].querySelector('[data-mv6-acc-chev]');
      if (chev) chev.style.transform = 'rotate(180deg)';
    }
  });

  ROOT.addEventListener('click', function (e) {
    var trig = e.target.closest ? e.target.closest('[data-mv6-a11y]') : null;
    if (trig && ROOT.contains(trig)) { e.preventDefault(); openA11y(); return; }
    var el = e.target.closest ? e.target.closest('[data-mv6-ft]') : null;
    if (!el || !ROOT.contains(el)) return;
    if (!isMobile()) return;
    var i = el.getAttribute('data-mv6-ft');
    var panel = ROOT.querySelector('[data-mv6-ft-panel="' + i + '"]');
    if (!panel) return;
    var on = el.getAttribute('aria-expanded') !== 'true';
    panel.style.display = on ? 'flex' : 'none';
    el.setAttribute('aria-expanded', on ? 'true' : 'false');
    var chev = el.querySelector('[data-mv6-acc-chev]');
    if (chev) chev.style.transform = on ? 'rotate(180deg)' : 'rotate(0deg)';
  });
})();
